import React, { useContext, useMemo } from "react";
import { useParams } from "react-router-dom";
import AuthContext from "../Auth/AuthContext";
import Layout from "../Layout/Layout";
import { AgencyContext } from "./AgencyProvider/AgencyProvider";
import Agent from "./Agent/Agent";
import ApiKey from "./APIKey/ApiKey";
import Billing from "./Billing/Billing";
import Profile from "./Profile/Profile";
import Usage from "./Usage/Usage";
import Webhooks from "./Webhooks";
import YourKeys from "./YourKeys/YourKeys";

const SettingsWrapper = () => {
  const { name = "profile" } = useParams();
  const { authUser } = useContext(AuthContext);
  const userRoles = authUser?.roles || [];
  const isSuperAdmin =
    userRoles.includes("superadmin") || authUser?.is_superuser;
  const agency = useContext(AgencyContext);
  const tabs = useMemo(() => {
    const defaultTabs = [
      { name: "Profile", route: "/settings/profile", component: Profile },
      // { name: "Channels", route: "/settings/channels", component: Channels },
      { name: "Webhooks", route: "/settings/webhooks", component: Webhooks },
      { name: "Usage", route: "/settings/usage", component: Usage },
      {
        name: agency?.myDetails?.agency_id ? "Billing" : "Billing & Wallet",
        route: "/settings/billing",
        component: Billing,
      },
      { name: "API Keys", route: "/settings/api-keys", component: ApiKey },
      {
        name: "Your Provider Keys",
        route: "/settings/your-keys",
        component: YourKeys,
      },
    ];

    if (isSuperAdmin) {
      defaultTabs.push({
        name: "Human Agents",
        route: "/settings/agents",
        component: Agent,
      });
    }
    return defaultTabs;
  }, [isSuperAdmin]);

  const defaultTab = tabs.findIndex((tab) => tab.route === `/settings/${name}`);
  const RenderComponent = tabs[defaultTab].component;

  return (
      <RenderComponent />
  );
};

export default SettingsWrapper;
